"use client";

import { c as _c } from "react/compiler-runtime";
import { useCart } from "@/queries/useCart";
import { OptionalAddOnCard } from "./OptionalAddOnCard";
import type { OptionalAddOn } from "./types";
interface Props {
  addOns: OptionalAddOn[];
}
const MAX_ADDONS_DISPLAYED = 3;
export function OptionalAddOns(t0) {
  const $ = _c(21);
  const {
    addOns
  } = t0;
  const {
    data: cart
  } = useCart();
  let skusInCart;
  if ($[0] !== cart?.items) {
    skusInCart = new Set();
    for (const item of cart?.items ?? []) {
      for (const sku of [item.sku?.marketingName, item.sku?.inferredMarketingName]) {
        if (sku) {
          skusInCart.add(sku);
        }
      }
    }
    $[0] = cart?.items;
    $[1] = skusInCart;
  } else {
    skusInCart = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== addOns || $[3] !== skusInCart) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t7;
      if ($[10] !== skusInCart) {
        t7 = addOn => !skusInCart.has(addOn.sku);
        $[10] = skusInCart;
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      const eligible = addOns.filter(t7).slice(0, MAX_ADDONS_DISPLAYED);
      if (eligible.length === 0) {
        t6 = null;
        break bb0;
      }
      t3 = "optional-addons-heading";
      t4 = "flex flex-col gap-4 px-5 pt-6";
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <h2 id="optional-addons-heading" className="text-lg font-semibold">Optional Add-ons</h2>;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      t1 = "grid grid-cols-3 grid-rows-[auto_auto_auto] gap-x-4";
      t2 = eligible.map(_temp);
    }
    $[2] = addOns;
    $[3] = skusInCart;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2) {
    t7 = <ul className={t1}>{t2}</ul>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <section aria-labelledby={t3} className={t4}>{t5}{t7}</section>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(addOn_0, index) {
  return <li key={addOn_0.id} className="grid grid-rows-subgrid row-span-3"><OptionalAddOnCard addOn={addOn_0} position={index + 1} /></li>;
}